// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"Edit__pc_only___3dkp0","sp_only":"Edit__sp_only___1eSfW","container":"Edit__container___1aFCY"};